var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fal fa-clipboard-user fa-fw mr-1"}),_vm._v(" "+_vm._s(_vm.$t('EVENTS.LABEL.WAITLIST_REGISTRATIONS'))+": "+_vm._s(_vm.numberOfWaitlistRegistrations)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }